import { MY_EVENTS } from '../ids';
import { InstallLocation } from '../types';
export const ids = MY_EVENTS;
export const getDefinition = (staticsUrl, t) => ({
    ...ids,
    installLocation: InstallLocation.Standalone,
    showInLoginMenu: false,
    showInMemberMenu: true,
    social: true,
    socialHome: false,
    method: 'addSection',
    menuOrder: 2,
    urlOverride: 'events',
    page: {
        name: t('membersEventsPageName'),
        shortDescription: t('membersEventsPageShortDescription'),
        description: t('membersEventsPageDescription'),
        origin: t('membersEventsPageOrigin'),
        iconURL: `${staticsUrl}assets/images/icons/events-icon.png`,
        screenshots: [
            `${staticsUrl}assets/images/my-events/my-events.png`,
            `${staticsUrl}assets/images/my-events/my-events-2.png`,
            `${staticsUrl}assets/images/my-events/mobile-my-events.png`,
            `${staticsUrl}assets/images/my-events/mobile-my-events-2.png`,
        ],
    },
});
//# sourceMappingURL=my-events.js.map